module.exports = __webpack_public_path__ + "img/img-carrusel-personas-mobile.da1761a.webp";